var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarliestArrival(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3043 1C7.78 1 4.91304 3.86695 4.91304 7.39131C4.91304 9.08638 5.58641 10.7121 6.78501 11.9106C7.98361 13.1092 9.60927 13.7826 11.3043 13.7826C14.8287 13.7826 17.6957 10.9248 17.6957 7.39131C17.6957 3.86695 14.8287 1 11.3043 1ZM11.3043 2.96304C13.7422 2.96304 15.7326 4.94435 15.7326 7.39131C15.7326 9.83829 13.7422 11.8196 11.3043 11.8196C10.1299 11.8196 9.00356 11.353 8.17309 10.5225C7.34263 9.6921 6.87609 8.56575 6.87609 7.39131C6.87609 6.21685 7.34263 5.09051 8.17309 4.26005C9.00356 3.42959 10.1299 2.96304 11.3043 2.96304ZM10.3913 4.65217V8.02131L13.3039 9.70131L13.9887 8.51435L11.7609 7.22695V4.65217H10.3913ZM4 14.6957V22H5.82609V19.2609H16.7826V22L20.4348 18.3478L16.7826 14.6957V17.4348H5.82609V14.6957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarliestArrival);
export default __webpack_public_path__ + "static/media/earliest-arrival.83e018ddb1303a8279cc669673555a37.svg";
export { ForwardRef as ReactComponent };